/**
 * Index of the "Compliance Content" step in `Tooltips.tsx` fullList (6-step tour,
 * when `customizationOfCanonical`). Keep in sync when reordering the tour.
 */
export const COMPLIANCE_CONTENT_TOOLTIP_INDEX = 1;
